module.exports = __webpack_public_path__ + "img/search.2bd0f5e9.svg";